import React from 'react';
import jss from 'jss';

import theme from '../../utils/theme';

const styles = (style) => ({
    root: {
        ...style,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: style.cursor || 'pointer',
        '@media print': {
            display: 'none',
        },
    },
});

export default function WarningIconComponent({ color, size = 10, customStyles, ...props }) {
    const { classes } = jss.createStyleSheet(styles({ ...customStyles })).attach();

    return (
        <span className={classes.root} {...props}>
            <svg width={`${size}px`} height={`${size}px`} viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.98501 2.10667L1.33835 11.5333C1.22193 11.735 1.16033 11.9635 1.15967 12.1964C1.15902 12.4292 1.21934 12.6581 1.33463 12.8604C1.44992 13.0626 1.61616 13.2312 1.81682 13.3492C2.01747 13.4673 2.24555 13.5308 2.47835 13.5333H13.7717C14.0045 13.5308 14.2326 13.4673 14.4332 13.3492C14.6339 13.2312 14.8001 13.0626 14.9154 12.8604C15.0307 12.6581 15.091 12.4292 15.0904 12.1964C15.0897 11.9635 15.0281 11.735 14.9117 11.5333L9.26501 2.10667C9.14617 1.91074 8.97883 1.74875 8.77914 1.63633C8.57946 1.52391 8.35417 1.46484 8.12501 1.46484C7.89586 1.46484 7.67057 1.52391 7.47088 1.63633C7.2712 1.74875 7.10386 1.91074 6.98501 2.10667V2.10667Z" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8.125 4.86719V8.86719" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8.125 10.8672V11.5339" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </span>
    );
}

WarningIconComponent.defaultProps = {
    color: theme.colors.error500,
    size: 10,
    type: 'button',
};

